import React from "react";
import { useForm, Controller } from "react-hook-form";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Typography, TextField, makeStyles } from "@material-ui/core";
import { FormControl, Select, MenuItem, InputLabel } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { convertDateFormatYYYYMMDD } from "./../../Utility/Utility";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: "white",
    color: "#4f2d7f",
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  submitButton: {
    width: "30%",
    marginTop: "1em",
    backgroundColor: "#4f2d7f",
    color: "#fff",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#4F2D7F",
    },
  },
  errorMessage: {
    color: "red",
    fontSize: "0.85rem",
    marginTop: "4px",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  thirdRowInputField: {
    width: "32%",
  },
  formRow: {
    display: "flex",
    gap: theme.spacing(2),
    // marginTop: "1.5em",
  },
  inputField: {
    flex: 1,
  },
  buttonRow: {
    textAlign: "center",
    marginTop: theme.spacing(2),
  },

  noteTxt: {
    fontSize: "0.7rem",
  },
  noteText: {
    marginTop: theme.spacing(2),
    color: "#555",
    fontSize: "0.7rem",
  },
}));

const PartBModal = ({
  generateModal,
  setGenerateModal,
  selectedRowGenerate,
  generateTransportDocDate,
  onSubmitForm,
  transportData
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();
  // const [transportData, setTransportData] = useState({
  //   transportDocDate: "",
  //   transportDistance: "0",
  //   transportDocNo: "",
  //   transportId: "",
  //   transportMode: "",
  //   transportNo: "",
  //   vehicleType: "",
  //   vehicleNo: "",
  // });

  const handleInputChange = (e, field, maxLength, regex, errorMessage) => {
    const { value } = e.target;
    if (value.length > maxLength) {
      setError(field.name, {
        type: "maxLength",
        message:
          field.name === "transporterId"
            ? `Enter a valid transportId with length of ${maxLength} characters only`
            : `Maximum ${maxLength} characters allowed`,
      });
      return;
    }
    if (regex && !regex.test(value)) {
      setError(field.name, {
        type: "pattern",
        message: errorMessage,
      });
      return;
    }
    setValue(field.name, value);
    clearErrors(field.name);
  };


  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="md"
      open={generateModal}
      onClose={() => setGenerateModal(false)}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Generate Part B"}</Typography>
          <CloseIcon
            onClick={() => setGenerateModal(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        <form
          onSubmit={handleSubmit(onSubmitForm)}
          className={classes.formContainer}
        >
          {/* First Row: Transport Mode, Transport Doc Number, Transport Doc Date */}
          <div className={classes.formRow}>
            <FormControl className={classes.inputField}>
              <InputLabel>Transport Mode</InputLabel>
              <Controller
                name="transportMode"
                control={control}
                defaultValue={transportData?.transportMode}
                render={({ field }) => (
                  <Select {...field}>
                    <MenuItem value="1">Road</MenuItem>
                    <MenuItem value="2">Rail</MenuItem>
                    <MenuItem value="3">Air</MenuItem>
                    <MenuItem value="4">Ship</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
            <Controller
              name="transportDocNumber"
              control={control}
              defaultValue={transportData?.transportDocNo}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Transport Doc Number"
                  className={classes.inputField}
                  error={!!errors.transportDocNumber}
                  helperText={errors.transportDocNumber?.message}
                  onChange={(e) =>
                    handleInputChange(
                      e,
                      field,
                      50,
                      /^[A-Za-z0-9]*$/,
                      "Only letters and numbers allowed"
                    )
                  }
                />
              )}
            />
            <Controller
              name="transportDocDate"
              control={control}
              defaultValue={convertDateFormatYYYYMMDD(
                transportData?.transportDocDate
              )}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Transport Doc Date"
                  type="date"
                  className={classes.inputField}
                  InputLabelProps={{ shrink: true }}
                  error={!!errors.transportDocDate}
                  helperText={errors.transportDocDate?.message}
                />
              )}
            />
          </div>
          {/* Second Row: Transporter ID, Vehicle No, Vehicle Type */}
          <div className={classes.formRow}>
            <Controller
              name="transporterId"
              control={control}
              defaultValue={transportData?.transportId}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Transporter ID"
                  className={classes.inputField}
                  error={!!errors.transporterId}
                  helperText={errors.transporterId?.message}
                  onChange={(e) =>
                    handleInputChange(
                      e,
                      field,
                      50,
                      
                    )
                  }
                />
              )}
            />
            <Controller
              name="vehicleNo"
              control={control}
              defaultValue={transportData?.vehicleNo}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Vehicle No"
                  className={classes.inputField}
                  error={!!errors.vehicleNo}
                  helperText={errors.vehicleNo?.message}
                  onChange={(e) =>
                    handleInputChange(
                      e,
                      field,
                      20,
                   
                    )
                  }
                />
              )}
            />
            <FormControl className={classes.inputField}>
              <InputLabel>Vehicle Type</InputLabel>
              <Controller
                name="vehicleType"
                control={control}
                defaultValue={transportData?.vehicleType}
                render={({ field }) => (
                  <Select {...field}>
                    <MenuItem value="R">Regular</MenuItem>
                    <MenuItem value="O">Over-Dimensional</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </div>
          {/* Third Row: Transporter Name, Transport Distance */}
          <div className={classes.formRow}>
            <Controller
              name="transporterName"
              control={control}
              defaultValue={transportData?.transportNo}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Transporter Name"
                  className={classes.thirdRowInputField}
                  error={!!errors.transporterName}
                  helperText={errors.transporterName?.message}
                  onChange={(e) =>
                    handleInputChange(
                      e,
                      field,
                      50,
                     
                    )
                  }
                />
              )}
            />
            <Controller
              name="transportDistance"
              control={control}
               defaultValue={transportData?.transportDistance}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Transport Distance"
                  className={classes.thirdRowInputField}
                  error={!!errors.transportDistance}
                  helperText={errors.transportDistance?.message}
                  onChange={(e) =>
                    handleInputChange(
                      e,
                      field,
                      50,
                      /^[0-9]*$/,
                      "Only numbers (0-9) allowed"
                    )
                  }
                />
              )}
            />
          </div>
          {/* Note Section */}
          <Typography className={classes.noteText}>
            <strong className={classes.noteTxt}>Note:</strong> If the distance
            is passed as 0 (Zero) and the distance between the PIN codes
            provided is available in the E-Way Bill database, the system will
            replace the distance as per the database. Passing 0 is an indication
            that the user wants the system to take the distance as per the E-Way
            Bill database. If the distance is passed and is differing by more
            than ±10% of the pin-to-pin distance stored in the system, the
            response will have a corresponding error code.
          </Typography>
          {/* Submit Button */}
          <div className={classes.buttonRow}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                textTransform: "capitalize",
                paddingLeft: "2em",
                paddingRight: "2em",
              }}
            >
              Submit
            </Button>
          </div>
        </form>
      </MuiDialogContent>
    </Dialog>
  );
};

export default PartBModal;
